"use client"

import { BodyDefault, BodyDefaultLight } from "@/components/text"
import Heading2 from "@/components/text/Heading2"
import { FaqList } from "@/lib/faqs"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@relume_io/relume-ui"

type FaqProps = {
  list: FaqList
  heading: string
  description: string
}

const Faq: React.FC<FaqProps> = ({ list, heading, description }) => {
  return (
    <div className="mx-auto w-full">
      <Heading2 className="mb-0 md:mb-0 text-center">{heading}</Heading2>
      <BodyDefault className="text-center md:mb-18 lg:mb-20">{description}</BodyDefault>
      <div className="max-w-2xl m-auto">
        <Accordion type="multiple" className="w-full AccordionChevron">
          {!!list.length &&
            list.map((item, index) => (
              <AccordionItem
                key={`item-faq_accordion-${index}`}
                value={`item-faq_accordion-${index}`}
                className="first:border-t border-b border-black overflow-hidden">
                <AccordionTrigger className="AccordionTrigger">
                  <BodyDefaultLight className="my-5 md:my-5 text-left">{item.question}</BodyDefaultLight>
                </AccordionTrigger>
                <AccordionContent className="md:pb-6 text-[1rem] pb-[1rem] pl-1">
                  <div className="text-[1rem] md:text-[1.125rem] font-medium leading-1.5 mb-[1.25rem] md:mb-[1.5rem] whitespace-pre-line">
                    {typeof item.answer === "string" ? <>{item.answer}</> : item.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
        </Accordion>
      </div>
    </div>
  )
}
export default Faq

// const _oldFaq = [
// {
//   question: "Wat is GoodShift",
//   answer:
//     "GoodShift is het innovatieve donatieplatform waar je gemakkelijk en flexibel kunt doneren aan al jouw favoriete goede doelen. Van een klein gebaar naar een grote impact",
// },
// {
//   question: "Hoe kan ik mijn donatie stopzetten?",
//   answer: (
//     <>
//       <p>Je kunt je donatie eenvoudig wijzigen in de app: </p>
//       <ol className="list-disc pl-4">
//         <li>Ga naar &apos;donaties&apos; in het menu van de app.</li>
//         <li>Klik op de betreffende donatie.</li>
//         <li>
//           Gebruik de &apos;edit&apos; functie (pen-icoontje) om de donatie per direct te starten, stoppen, wijzigen of
//           pauzeren.
//         </li>
//         <li>Jouw gegevens worden zonder toestemming niet met derden gedeeld.</li>
//       </ol>
//     </>
//   ),
// },
// {
//   question: "Moet ik een incassomachtigiging afgeven?",
//   answer:
//     "Voor maandelijkse donaties is een incassomachtiging nodig. Dit kun je eenvoudig beheren in je persoonlijke account. Bij je eerste donatie geef je toestemming via iDEAL | Wero. Daarna worden donaties automatisch uitgevoerd. Eenmalige donaties hebben geen incassomachtiging nodig.Je kunt er wel voor kiezen een machtiging af te geven voor ‘doneren met één klik’.Hierdoor kun je het iDEAL | Wero proces overslaan elke keer dat je geeft.",
// },
// {
//   question: "Wat zijn GoodShift giftcards?",
//   answer:
//     "Met de GoodShift giftcards kunnen organisaties samen met werknemers, klanten of leden op een transparante en eenvoudige manier een maatschappelijke bijdrage leveren. Via onze app is het mogelijk om de giftcard te verzilveren. Vervolgens is het donatiebedrag via de GoodShift app in te zetten voor een eenmalige donatie aan één goed doel. Voor vragen over het gebruik of over de aanschaf van de GoodShift giftcards kun je contact opnemen via hello@goodshift.nl.",
// },
// {
//   question: "Hoe werkt het gebruik van de GoodShift giftcard?",
//   answer: (
//     <>
//       <p>Volg na het downloaden van de app en een eenmalige registratie de volgende stappen:</p>
//       <ul className="list-disc pl-4">
//         <li>Ga naar de pagina van het goede dol ewat je wilt steunen</li>
//         <li>Klik op &quot;Geef&quot; en selecteer &quot;Gebruik mijn Donatie giftcard&quot;</li>
//         <li>Controleer en bevestig de donatie. Zo eenvoudig is het!</li>
//       </ul>
//     </>
//   ),
// },
// {
//   question: "Kan ik het bedrag van een giftcard splitsen tussen twee goede doelen?",
//   answer:
//     "Nee, het is nu nog niet mogelijk het bedrag te splitsen. Je kunt met de GoodShift giftcard eenmalig één goed doel steunen.",
// },
// {
//   question: "Kan ik een donatie ook laten terugstorten als ik me bedenk?",
//   answer:
//     "Ja, je kunt een donatie laten terugstorten. Neem binnen 4 weken contact met ons op via XXX en wij regelen het voor je.",
// },
// {
//   question: "Waarom zie ik mijn bankrekeningnummer niet in de app?",
//   answer:
//     "GoodShift slaat uit privacyoverwegingen geen bankrekeningnummers op. Betalingen en machtigingen lopen via het betaalplatform Mollie.",
// },
// {
//   question: "Kan ik anoniem doneren?",
//   answer:
//     "Ja, je kunt anoniem doneren. We vragen alleen je e- mailadres voor registratie en zorgen ervoor dat je gegevens niet met derden worden gedeeld.Voor meer informatie kun je onze privacy policy raadplegen.",
// },
// {
//   question: "Waar kan ik de giftcards kopen?",
//   answer:
//     "Voor vragen over de aanschaf van de GoodShift giftcards voor organisaties, kun je contact opnemen via hello@goodshift.nl.Binnenkort is het ook mogelijk voor particulieren om giftcards te bestellen. Stuur ons een e-mail als je een bericht wilt ontvangen wanneer dat mogelijk is.",
// },
// {
//   question: "Welke goede doelen zitten er in de app?",
//   answer:
//     "Alle goede doelen met een CBF-keurmerk of ANBI-status kunnen zich aansluiten bij GoodShift. We richten ons niet alleen op grote organisaties, maar ook op kleine lokale initiatieven. Lees meer over onze procedure voor onboarding van goede doelen. Wij zijn continu bezig met het uitbreiden van ons aanbod aan goede doelen. Heb jij een suggestie voor een nieuw goed doel? Geef het door via Whatsapp of stuur een e-mail naar hello@goodshift.nl.",
// },
// {
//   question: "Wat betalen goede doelen aan GoodShift?",
//   answer:
//     "Goede doelen kunnen zich gratis aanmelden en zijn via de zoekfunctie in de app te vinden. Voor extra zichtbaarheid (bijvoorbeeld via thema's of themabundels) vragen wij vanaf 2025 een bijdrage om de kosten van de stichting te dekken.",
// },
// {
//   question: "Zijn donaties via GoodShift aftrekbaar van de belasting?",
//   answer:
//     "Ja, GoodShift is door de belastingdienst erkend als donatieplatform voor ANBI-doelen. Dit betekent dat donaties aan ANBI-doelen via GoodShift hun ANBI-status behouden en belastingvoordeel opleveren.",
// },
// {
//   question: "Heeft GoodShift een klachtenprocedure?",
//   answer: "We hopen natuurlijk dat niemand het nodig heeft maar onze klachtenprocedure is hier te lezen.",
// },
// ]
